module.exports = __webpack_public_path__ + "static/media/1.2 Nachtlandschaft waehrend FA klein.e81947d7.jpg";